<template>
    <div class="clearfix rounded pb-5 mx-auto"> <!-- Abdullah added classes here  -->

        <!-- Abdullah added this code  -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Cost Centers<span>
                <!-- AbdullahALC chnaged pageurl to api url -->
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / Cost Centers</span>
        </h4>

        <div class="row no-margin mt-4">
            <!-- Abdullah Chnaged classses here. was clearfix company-form-container rounded mt-4 pb-5 mx-auto px-3 -->
            <!-- Abdullah Commented this code  -->
            <!-- <div class="clearfix row py-2 mb-2 border-bottom">
                <div class="col-sm-12 px-3 company-form-box-title">Cost Center <span class="font-weight-normal">( for Accounting JV)</span></div>
            </div>
            <div class="clearfix row py-2 mb-2 border-bottom">
                <div class="col-sm-6">
                    <div class="custom-search">
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search Cost Center" v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
                <div class=" col-sm-6 float-right text-right pr-0">
                    <b-button id="show-btn" class="mr-3" @click="processCostCenter()" :allowedExtensions = "extensions"><b-icon icon="upload" ></b-icon> Import </b-button>
                    <b-button :href="'/cost-center-export'" class="mr-3"><b-icon icon="download"></b-icon> Export</b-button>
                    <b-button id="show-btn" class="mr-3" @click="addCostCenter()"><b-icon icon="plus" ></b-icon> Add Cost Center</b-button>
                </div>
            </div> -->

            <!-- Abdullah aded this code`` -->
            <div class="ibox col-md-12 px-4">
                <div class="ibox-title dashboard_title px-0">
                    <h4>Cost Centers</h4>
                </div>
                <div class="ibox-content px-0 pt-4 employee-table-wrapper">
                    <div class="row no-gutters py-2 mb-3 pl-0 ">
                        <div class="col-sm-6">
                            <div class="custom-search">
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search.. " v-model="search"
                                        @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                        <div class=" col-sm-6 float-right text-right pr-0">
                            <b-button id="show-btn" class="mr-3 custom-wizard-btn" @click="processCostCenter()"
                                :allowedExtensions="extensions"><b-icon icon="upload"></b-icon> Import </b-button>
                            <b-button :href="'/cost-center-export'" class="mr-3 custom-wizard-btn"><b-icon
                                    icon="download"></b-icon> Export</b-button>
                            <b-button id="show-btn" class="" @click="addCostCenter()">Add Cost Center</b-button>
                        </div>
                    </div>

                    <b-overlay :show="showoverlay" rounded="sm" class="table-left-margin">
                        <table class="table dataTable no-sort-icon leave-table">
                            <thead>
                                <tr class="table-head">
                                    <th v-for="column in columns" :key="column.name" @click="sortBy(column.reorder)"
                                        :class="sortKey === column.reorder ? (sortOrders[column.reorder] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                        style="cursor:pointer;">{{ column.label }}</th>
                                    <th class="text-center">Generate Components</th>
                                    <th class="text-right">Actions</th>
                                </tr>
                            </thead>
                            <draggable :list="paginatedData" :options="{ animation: 200, handle: '.my-handle' }"
                                :element="'tbody'" @change="updateSorting">
                                <tr class="hover-bg table-row border-bottom mx-2"
                                    v-for="(costcenter, index) in paginatedData" :key="costcenter.id">
                                    <td><b-icon class="my-handle" icon="arrows-move" aria-hidden="true"></b-icon></td>
                                    <td class="my-handle">{{ costcenter.name }}</td>
                                    <td class="my-handle">{{ costcenter.code }}</td>
                                    <td class="my-handle">{{ costcenter.short_code }}</td>
                                    <td class="my-handle" v-if="costcenter.status == 0">Disabled</td>
                                    <td class="my-handle" v-else>Enabled</td>
                                    <td class="my-handle text-center">
                                        <b-button variant="secondary" @click="showDetails(costcenter.id)">
                                            Generate
                                        </b-button>
                                    </td>
                                    <td>
                                        <div class="float-right position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown"
                                                    class="dropdown-toggle clearfix action-dropdown-toggle"
                                                    style="font-size: 16px;" href="#" role="button"
                                                    data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false"><b-icon
                                                        icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu"
                                                    aria-labelledby="actionDropdown">
                                                    <b-button-group>
                                                        <!-- alpha fix- added title  -->
                                                        <b-button variant="outline-secondary"
                                                         title="Edit"
                                                            @click="editCostCenter(costcenter.id)">
                                                            <b-icon icon="pencil"></b-icon> Edit
                                                        </b-button>
                                                        <!-- alpha fix added title  -->
                                                        <b-button variant="outline-secondary"
                                                         title="Show Details"
                                                            @click="showDetails(costcenter.id)">
                                                            <b-icon icon="view-list"></b-icon> Show Details
                                                        </b-button>
                                                         <!-- alpha fix- added tile -->
                                                        <b-button variant="outline-secondary"

                                                        title="Delete"
                                                            @click="deleteCostCenter(costcenter.id)"
                                                            v-if="costcenter.emp_assigned == 'no'">
                                                            <b-icon icon="trash"></b-icon> Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{ blankmsg }}</div>
                        <div v-else class="row py-2 no-margin">
                            <div class="col-md-12 p-0 no-margin">
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length"
                                            :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{ pagination.total }} records
                                        found.</li>
                                </ul>
                                <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                                    base-url="#" prev-text="Previous" next-text="Next" first-number
                                    last-number></b-pagination-nav>
                            </div>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>
        <!-- Abdullah aded this code``upto this -->

        <div class="row justify-content-center">
            <!-- excel file upload modal starts -->
            <div class="col-sm-12  px-0">
                <b-modal id="bv-modal-cost-center-import" size="lg" hide-footer title="Cost Center Details">
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="onSubmitUploadFile" class="">
                            <b-form-group id="file-group" label="Upload Cost Center File" class="required-field"
                                label-for="file"> <!-- Abdullah removed class from here. half-width mr1 -->
                                <b-form-file v-model="cost_center_file" id="cost_center_file"
                                    @change="onChangeFile"></b-form-file>
                            </b-form-group>
                            <div class="btn-wrapper text-center pt-5">
                                <!-- Abdullah chnaged class here. was full-width-->
                                <b-button type="submit" variant="primary">Submit</b-button>
                                <!-- Abdullah chnaged varient here. from success to primary-->
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
            </div>

            <!-- cost center add edit modal starts -->
            <div class="col-sm-12  px-0">
                <b-modal id="bv-modal-cost-center" size="lg" hide-footer :title="cost_center_details">
                    <!-- Abdullah chnaged title here. was title="Cost Center Details-->
                    <b-overlay :show="showoverlay" rounded="sm">

                        <b-form @submit.stop.prevent="onSubmit" class="">
                            <input type="hidden" v-model="costdata.id" name="id">
                            <div class="clearfix row">

                                <div class="col-md-6">
                                    <b-form-group id="name-group" label="Cost Center Name" class="required-field"
                                        label-for="name"
                                        :style="(veeErrors.has('code') && !veeErrors.has('name')) ? 'margin-bottom: 39px' : ''">

                                        <!-- AbdullahALC chnaged here added class="radius-8" -->
                                        <b-input-group>
                                            <b-form-input class="radius-8" id="name" name="name" v-model="costdata.name"
                                                v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                                                aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                            <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                                }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>

                                    <b-form-group id="short_code-group" label="Short Code" class=""
                                        label-for="short_code">
                                        <b-input-group>
                                            <b-form-input id="short_code" name="short_code"
                                                v-model="costdata.short_code"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>

                                </div>

                                <div class="col-md-6">
                                    <!-- AbdullahALC chnaged here removed class="radius-8" -->
                                    <b-form-group id="code-group" label="Cost Center Code" class="required-field"
                                        label-for="code"
                                        :style="(veeErrors.has('name') && !veeErrors.has('code')) ? 'margin-bottom: 39px' : ''">
                                        <b-input-group>
                                            <b-form-input class="radius-8" id="code" name="code" v-model="costdata.code"
                                                v-validate="{ required: true }" :state="validateState('code')"
                                                aria-describedby="code-feedback" data-vv-as="Code"></b-form-input>
                                            <b-form-invalid-feedback id="code-feedback">{{ veeErrors.first('code')
                                                }}</b-form-invalid-feedback>
                                        </b-input-group>
                                    </b-form-group>

                                    <b-form-group id="status-group" label="Status" class="required-field"
                                        label-for="status">
                                        <b-form-select id="status" name="status" v-model="costdata.status"
                                            v-validate="{ required: true }" :options="status"
                                            :state="validateState('status')" aria-describedby="status-feedback"
                                            data-vv-as="Status"></b-form-select>
                                        <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status')
                                            }}</b-form-invalid-feedback>
                                    </b-form-group>

                                </div>



                            </div>

                            <!-- AbdullahALC chnaged here removed the btn outside of the div -->
                            <div class="btn-wrapper text-center pt-5">
                                <!-- Abdullah chnaged class here. was full-width-->
                                 <!-- alpha fix- make the btn dynamic  -->
                                <b-button type="submit" variant="primary">{{ edit_cost ? 'Update' : 'Submit' }}</b-button>
                                <!-- Abdullah chnaged varient here. was success-->
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
            </div>
            <!-- cost center add edit modal ends -->
            <!-- table for cost cneter options details starts -->
            <div class="col-sm-12  px-0">
                <b-modal id="bv-modal-show-cost-center" size="lg" hide-footer :title="cost_center_name + ' GL MAP'">
                    <input type="hidden" v-model="cost_center_id">
                    <div class="employee-table-wrapper"> <!-- Abdullah added this div -->
                        <b-overlay :show="showoverlay" rounded="sm" class="table-left-margin">
                            <!-- Abdullah added class here. -->
                            <table class="table dataTable">
                                <thead>
                                    <tr class="table-head">
                                        <th v-for="dcolumn in detailColumns" :key="dcolumn.name">{{ dcolumn.label }}</th>
                                        <th class="text-right">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="centerdetail_basic in costcenterdetails_basic"
                                        :key="centerdetail_basic.id">
                                        <td>{{ centerdetail_basic.payroll_component }}</td>
                                        <td>{{ centerdetail_basic.debit_credit }}</td>
                                        <td>{{ centerdetail_basic.gl_account_name }}</td>
                                        <td>{{ centerdetail_basic.gl_account_code }}</td>
                                        <td>
                                            <div class="float-right position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <!-- alpha fix- added title to this btn  -->
                                                            <b-button variant="outline-secondary"
                                                              title="Edit"
                                                                @click="editCostCenterPayroll(centerdetail_basic.id)">
                                                                <b-icon icon="pencil"></b-icon> Edit
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="centerdetail_hr in costcenterdetails_house_rent"
                                        :key="centerdetail_hr.id">
                                        <td>{{ centerdetail_hr.payroll_component }}</td>
                                        <td>{{ centerdetail_hr.debit_credit }}</td>
                                        <td>{{ centerdetail_hr.gl_account_name }}</td>
                                        <td>{{ centerdetail_hr.gl_account_code }}</td>
                                        <td>
                                            <div class="float-right position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <!-- alpha fix- added title  -->
                                                            <b-button variant="outline-secondary"
                                                                title="Edit"
                                                                @click="editCostCenterPayroll(centerdetail_hr.id)">
                                                                <b-icon icon="pencil"></b-icon> Edit
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="centerdetail_ca in costcenterdetails_conveyance"
                                        :key="centerdetail_ca.id">
                                        <td>{{ centerdetail_ca.payroll_component }}</td>
                                        <td>{{ centerdetail_ca.debit_credit }}</td>
                                        <td>{{ centerdetail_ca.gl_account_name }}</td>
                                        <td>{{ centerdetail_ca.gl_account_code }}</td>
                                        <td>
                                            <div class="float-right position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <!-- alpha fix added title  -->
                                                            <b-button variant="outline-secondary"
                                                             title="Edit"
                                                                @click="editCostCenterPayroll(centerdetail_ca.id)">
                                                                <b-icon icon="pencil"></b-icon> Edit
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="centerdetail_ma in costcenterdetails_medical" :key="centerdetail_ma.id">
                                        <td>{{ centerdetail_ma.payroll_component }}</td>
                                        <td>{{ centerdetail_ma.debit_credit }}</td>
                                        <td>{{ centerdetail_ma.gl_account_name }}</td>
                                        <td>{{ centerdetail_ma.gl_account_code }}</td>
                                        <td>
                                            <div class="float-right position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <!-- alpha fix- added title  -->
                                                            <b-button variant="outline-secondary"
                                                             title="Edit"
                                                                @click="editCostCenterPayroll(centerdetail_ma.id)">
                                                                <b-icon icon="pencil"></b-icon> Edit
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                    <div id="show_div">

                                    </div>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="centerdetail_other in costcenterdetails_other"
                                        :key="centerdetail_other.id">
                                        <td><template
                                                v-if="centerdetail_other.payroll_component == 'Display Loan in Payslip'">Loan
                                                Distributed</template><template
                                                v-else>{{ centerdetail_other.payroll_component }}</template></td>
                                        <td>{{ centerdetail_other.debit_credit }}</td>
                                        <td>{{ centerdetail_other.gl_account_name }}</td>
                                        <td>{{ centerdetail_other.gl_account_code }}</td>
                                        <td>
                                            <div class="float-right position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <!-- alpha fix added title  -->
                                                            <b-button variant="outline-secondary"
                                                             title="Edit"
                                                                @click="editCostCenterPayroll(centerdetail_other.id)">
                                                                <b-icon icon="pencil"></b-icon> Edit
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="centerdetail_credit in costcenterdetails_credit"
                                        :key="centerdetail_credit.id">
                                        <td>{{ centerdetail_credit.payroll_component }}</td>
                                        <td>{{ centerdetail_credit.debit_credit }}</td>
                                        <td>{{ centerdetail_credit.gl_account_name }}</td>
                                        <td>{{ centerdetail_credit.gl_account_code }}</td>
                                        <td>
                                            <div class="float-right position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <!-- alpha fix- added title  -->
                                                            <b-button variant="outline-secondary"
                                                             title="Edit"
                                                                @click="editCostCenterPayroll(centerdetail_credit.id)">
                                                                <b-icon icon="pencil"></b-icon> Edit
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="centerdetail_income in costcenterdetails_income_tax"
                                        :key="centerdetail_income.id">
                                        <td>{{ centerdetail_income.payroll_component }}</td>
                                        <td>{{ centerdetail_income.debit_credit }}</td>
                                        <td>{{ centerdetail_income.gl_account_name }}</td>
                                        <td>{{ centerdetail_income.gl_account_code }}</td>
                                        <td>
                                            <div class="float-right position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <!-- alpha fix- added title  -->
                                                            <b-button variant="outline-secondary"
                                                             title="Edit"
                                                                @click="editCostCenterPayroll(centerdetail_income.id)">
                                                                <b-icon icon="pencil"></b-icon> Edit
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="centerdetail_oneOff in costcenterdetails_one_off"
                                        :key="centerdetail_oneOff.id">
                                        <td>{{ centerdetail_oneOff.payroll_component }}</td>
                                        <td>{{ centerdetail_oneOff.debit_credit }}</td>
                                        <td>{{ centerdetail_oneOff.gl_account_name }}</td>
                                        <td>{{ centerdetail_oneOff.gl_account_code }}</td>
                                        <td>
                                            <div class="float-right position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <!-- alpha fix- added title  -->
                                                            <b-button variant="outline-secondary"
                                                             title="Edit"
                                                                @click="editCostCenterPayroll(centerdetail_oneOff.id)">

                                                                <b-icon icon="pencil"></b-icon> Edit
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="centerdetail_netp in costcenterdetails_net_paid"
                                        :key="centerdetail_netp.id">
                                        <td>{{ centerdetail_netp.payroll_component }}</td>
                                        <td>{{ centerdetail_netp.debit_credit }}</td>
                                        <td>{{ centerdetail_netp.gl_account_name }}</td>
                                        <td>{{ centerdetail_netp.gl_account_code }}</td>
                                        <td>
                                            <div class="float-right position-relative">
                                                <b-button-toolbar>
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <!-- alpha fix- added title   -->
                                                            <b-button variant="outline-secondary"
                                                             title="Edit"
                                                                @click="editCostCenterPayroll(centerdetail_netp.id)">
                                                                <b-icon icon="pencil"></b-icon> Edit
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </b-button-toolbar>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-overlay>
                    </div>
                </b-modal>
            </div>
            <!-- table for cost cneter options details ends -->
            <!-- edit modal for cost center option starts -->
            <div class="col-sm-12  px-0">
                 <!-- alpha fix- chnaged title here  -->
                <b-modal id="bv-modal-show-edit-details" size="lg" hide-footer

                    title="Edit Cost Center Payroll Components">
                    <input type="hidden" v-model="cost_center_id">
                    <input type="hidden" v-model="company_id">
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="onSubmitCostCenterOptions" class="">
                            <input type="hidden" v-model="costdata_payroll.id" name="id">
                            <div class="clearfix">
                                <b-form-group id="payroll_component-group" label="Payroll Component"
                                    class="required-field half-width mr1" label-for="payroll_component">
                                    <b-input-group>

                                        <!-- // AbdullahALC chnaged added this code, added class radius-8 -->
                                        <b-form-input class="radius-8" id="payroll_component" name="payroll_component"
                                            v-model="costdata_payroll.payroll_component"
                                            v-validate="{ required: true, min: 3 }"
                                            :state="validateState('payroll_component')"
                                            aria-describedby="costdata_detail_payroll-feedback"
                                            data-vv-as="payroll_component" readonly></b-form-input>
                                        <b-form-invalid-feedback id="payroll_component-feedback">{{
                                            veeErrors.first('payroll_component') }}</b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group id="debit_credit-group" label="Debit/Credit"
                                    class="required-field half-width " label-for="debit_credit">
                                    <b-input-group>
                                        <b-form-input id="debit_credit" name="debit_credit"
                                            v-model="costdata_payroll.debit_credit" v-validate="{ required: true }"
                                            :state="validateState('debit_credit')"
                                            aria-describedby="debit_credit-feedback" data-vv-as="debit_credit"
                                            readonly></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group id="gl_account_name-group" label="GL Account Name"
                                    class="required-field half-width mr1" label-for="gl_account_name">
                                    <b-input-group>
                                        <b-form-input id="gl_account_name" name="gl_account_name"
                                            v-model="costdata_payroll.gl_account_name" v-validate="{ required: true }"
                                            :state="validateState('gl_account_name')"
                                            aria-describedby="gl_account_name-feedback"
                                            data-vv-as="GL Account Name"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group id="gl_account_code-group" label="GL Account Code"
                                    class="required-field half-width mr1" label-for="gl_account_code">
                                    <b-input-group>
                                        <b-form-input id="gl_account_code" name="gl_account_code"
                                            v-model="costdata_payroll.gl_account_code" v-validate="{ required: true }"
                                            :state="validateState('gl_account_code')"
                                            aria-describedby="gl_account_code-feedback"
                                            data-vv-as="GL Account Code"></b-form-input>
                                    </b-input-group>
                                </b-form-group>

                            </div>

                            <!-- // AbdullahALC chnaged added this code, make the btn outside of the div  -->
                            <div class="btn-wrapper text-center pt-5">
                                <!-- alpha fix- bnamed btn updateb  -->
                                <b-button type="submit" variant="primary">Update</b-button>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
            </div>
            <!-- edit modal for cost center option ends -->
            <!-- table for all cost center data starts  -->
            <!-- Abdullah commented this code  -->
            <!-- <div class="col-sm-12  px-0">
                    <table class="table dataTable">

                        <thead>
                            <tr class="table-head">
                                <th v-for="column in columns" :key="column.name" @click="sortBy(column.reorder)" :class="sortKey === column.reorder ? (sortOrders[column.reorder] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;"><span>{{column.label}}</span></th>
                                <th class="text-center">Generate Components</th>
                                <th class="text-right">Actions</th>
                            </tr>
                        </thead>
                            <draggable :list="paginatedData" :options="{animation:200, handle:'.my-handle'}" :element="'tbody'" @change="updateSorting">
                            <tr class="hover-bg table-row border-bottom mx-2" v-for="(costcenter, index) in paginatedData" :key="costcenter.id">
                                <td><b-icon class= "my-handle" icon="arrows-move" aria-hidden="true"></b-icon></td>
                                <td class= "my-handle">{{costcenter.name}}</td>
                                <td class= "my-handle">{{costcenter.code}}</td>
                                <td class= "my-handle">{{costcenter.short_code}}</td>
                                <td class= "my-handle" v-if="costcenter.status == 0">Disabled</td>
                                <td class= "my-handle" v-else>Enabled</td>
                                <td class= "my-handle text-center">
                                    <b-button variant="secondary" @click="showDetails(costcenter.id)">
                                        Generate
                                    </b-button>
                                </td>
                                <td>
                                    <div class="float-right position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                <b-button-group >
                                                    <b-button variant="outline-secondary" @click="editCostCenter(costcenter.id)">
                                                        <b-icon icon="pencil"></b-icon> Edit
                                                    </b-button>
                                                    <b-button variant="outline-secondary" @click="showDetails(costcenter.id)">
                                                        <b-icon icon="view-list"></b-icon> Show Details
                                                    </b-button>
                                                    <b-button variant="outline-secondary" @click="deleteCostCenter(costcenter.id)" v-if="costcenter.emp_assigned == 'no'">
                                                        <b-icon icon="trash"></b-icon> Delete
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </td>
                            </tr>

                            <tr v-if="paginatedData.length > 0"><td :colspan=6>
                            <div class="row p-2 float-right" >
                                <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                            </div></td></tr>
                            <tr v-if="paginatedData.length == 0"><td :colspan=6>{{blankmsg}}</td></tr>
                        </draggable>
                    </table>
                </div> -->
            <!-- Abdullah commented this code. upto this.  -->
            <!-- table for all cost center data ends  -->
        </div>


        <!-- Abdullah commented this code -->
        <!-- <div class="clearfix company-form-container rounded mt-4 pb-5 mx-auto px-3">
            <div class="clearfix row py-2 mb-2 border-bottom" v-if="costcenters.length > 0">
                <div class="col-sm-12 px-3 company-form-box-title">GL Account Names and Codes</div>
            </div>
            <div class="clearfix row py-2 mb-2" v-if="costcenters.length > 0">
                <div class="col-sm-6">
                    <p>To map GL Account Names and Codes with the Cost Centers, click Export option to get the uploadable template.</p>
                </div>
                <div class=" col-sm-6 float-right text-right pr-0">
                    <b-button id="show-btn" class="mr-3" @click="importCostCenter()" :allowedExtensions = "extensions" v-if="costcenters.length > 0"><b-icon icon="upload" ></b-icon> Import </b-button>
                    <b-button :href="'/cost-center-export-data'" class="mr-3" v-if="costcenters.length > 0"><b-icon icon="download"></b-icon> Export</b-button>
                </div>
            </div>

            <b-modal id="bv-modal-cost-center-process" size="lg" hide-footer title="Import Cost Centers">
                <b-overlay :show="showoverlay" rounded="sm">
                    <b-form @submit.stop.prevent="onSubmitUploadFileProcess" class="">
                        <b-form-group id="file-group" label="Upload Cost Center File" class="required-field half-width mr1" label-for="file">
                            <b-form-file v-model="cost_center_file_process" id="cost_center_file_process" @change="onChangeFileProcess"></b-form-file>
                        </b-form-group>
                        <div class="full-width">
                            <b-button type="submit" variant="success">Submit</b-button>
                        </div>
                    </b-form>
                </b-overlay>
            </b-modal>
        </div> -->
        <!-- Abdullah commented this code. upto this. -->

        <!-- Abdullah added this code here  -->
        <div class="row no-margin mt-4" v-if="costcenters.length > 0">
            <div class="ibox col-md-12 px-4">
                <div class="ibox-title dashboard_title px-0">
                    <h4>GL Account Names and Codes</h4>
                </div>
                <div class="ibox-content px-0 pt-4 employee-table-wrapper">
                    <div class="clearfix row py-2 mb-2 no-margin">
                        <div class="col-sm-6">
                            <p>To map GL Account Names and Codes with the Cost Centers, click Export option to get the
                                uploadable template.</p>
                        </div>
                        <div class=" col-sm-6 float-right text-right pr-0">
                            <b-button id="show-btn" class="mr-3 custom-wizard-btn" @click="importCostCenter()"
                                :allowedExtensions="extensions" v-if="costcenters.length > 0"><b-icon
                                    icon="upload"></b-icon>
                                Import </b-button>
                            <b-button :href="'/cost-center-export-data'" class="custom-wizard-btn"
                                v-if="costcenters.length > 0"><b-icon icon="download"></b-icon> Export</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- cost center import modal starts -->
        <b-modal id="bv-modal-cost-center-process" size="lg" hide-footer title="Import Cost Centers">
            <b-overlay :show="showoverlay" rounded="sm">
                <b-form @submit.stop.prevent="onSubmitUploadFileProcess" class="">
                    <b-form-group id="file-group" label="Upload Cost Center File" class="required-field"
                        label-for="cost_center_file_process">
                        <b-form-file v-model="cost_center_file_process" id="cost_center_file_process"
                            @change="onChangeFileProcess"></b-form-file>
                    </b-form-group>
                    <div class="btn-wrapper text-center pt-5">
                        <b-button type="submit" variant="primary">Submit</b-button>
                    </div>
                </b-form>
            </b-overlay>
        </b-modal>
    </div>

</template>
<script>
import draggable from 'vuedraggable'
export default {
    components: {
        draggable
    },
    data() {
        let sortOrders = {};
        let columns = [
            { label: 'Reorder', name: 'reorder' },
            { label: 'Name', name: 'name' },
            { label: 'Code', name: 'code' },
            { label: 'Short Code', name: 'short_code' },
            { label: 'Status', name: 'status' },
        ];
        let detailColumns = [
            { label: 'Payroll Components', name: 'payrollcomponents' },
            { label: 'Debit/Credit', name: 'debitcredit' },
            { label: 'GL Account Name', name: 'GLAccountName' },
            { label: 'GL Account Code', name: 'GLAccountCode' }
        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });
        return {
            costcenters: [],
            successmsg: false,
            warningmsg: false,
            dangermsg: false,
            edit_user: false,
            edit_cost: false,
            disableme: false,
            showoverlay: false,
            costdata: {
                id: null,
                name: '',
                code: '',
                short_code: '',
                // AbdullahFixed chnaged here
                status: null
            },
            status: [
                { value: null, text: "Select..." },
                { value: "0", text: "Disabled" },
                { value: "1", text: "Enabled" },
            ],
            costdata_payroll: {
                id: null,
                cost_center_id: '',
                payroll_component: '',
                debit_credit: '',
                gl_account_name: '',
                gl_account_code: '',
                company_id: ''
            },
            search: '',

            blankmsg: 'Fetching data..',
            columns: columns,
            detailColumns: detailColumns,
            // sortKey: 'name',
            sortKey: 'reorder',
            sortOrders: sortOrders,
            length: 10,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            costcenterdetails: [],
            costcenterdetails_basic: [],
            costcenterdetails_house_rent: [],
            costcenterdetails_conveyance: [],
            costcenterdetails_medical: [],
            costcenterdetails_other: [],
            costcenterdetails_credit: [],
            costcenterdetails_income_tax: [],
            costcenterdetails_one_off: [],
            costcenterdetails_net_paid: [],
            short_code: '',
            cost_center_name: '',
            cost_center_id: '',
            costdata_detail_payroll: '',
            company_id: '',
            extensions: '.xls, .xlsx',
            cost_center_file: [],
            cost_center_file_process: null,

            // AbdullahALC chnaged added this code

            length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
            temp_length: 20,

            cost_center_details: 'Add New Cost Centers',

            // AbdullahALC chnaged added this code upto this
        }
    },
    methods:
    {
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetOptionsForm() {
            this.costdata_payroll = {
                id: null,
                cost_center_id: '',
                payroll_component: '',
                debit_credit: '',
                gl_account_name: '',
                gl_account_code: '',
                company_id: ''
            };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        resetAll() {
            // this.cost_center_file=  '';
            this.cost_center_file = null;
            this.cost_center_file_process = null;
        },
        resetForm() {
            this.costdata = {
                id: null,
                name: '',
                code: '',
                shortcode: '',
                // AbdullahFixed chnaged here
                status: null
            };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addCostCenter() {
            this.resetForm();
            // AbdullahALC chnaged added this code
            this.cost_center_details = 'Add New Cost Centers';
            // AbdullahALC chnaged added this code upto this
            this.$bvModal.show('bv-modal-cost-center');
            // alpha fix- added this line
            this.edit_cost = false ;
        },
        onSubmit(e) {
            e.preventDefault();
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();
                for (let [key, value] of Object.entries(this.costdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                }

                this.showoverlay = true;

                axios.post(this.$api_url + '/cost-center-save', formData, config)
                    .then(function (response) {
                        if (response.data.message != 'Saved') {
                            this.$bvToast.toast(response.data.message, {
                                title: `Failed`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                        else {
                            this.$bvToast.toast("Saved", {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                            this.costcenters = response.data.costcenters;
                            this.$bvModal.hide('bv-modal-cost-center');
                            this.resetForm();
                            this.getAllCostCenters();
                        }
                    }.bind(this))
                    .catch(function (error) //server error
                    {
                        currentObj.serverError(error);
                    });

                this.showoverlay = false;
            });
        },
        getAllCostCenters: function () {
            axios.get(this.$api_url + '/all-cost-center', {
                params: {
                }
            }).then(function (response) {
                this.costcenters = response.data;

                if (this.costcenters.length == 0)
                    this.blankmsg = "Nothing found.";

            }.bind(this));
        },
        editCostCenter: function (x) {
            this.resetForm();
            // AbdullahALC chnaged added this code
            this.cost_center_details = 'Edit Cost Centers';
            // AbdullahALC chnaged added this code upto this
            axios.get(this.$api_url + '/cost-center-details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.costdata = response.data;
                this.edit_user = true;
                // alpha fix- added this line
                this.edit_cost = true ;
                this.disableme = true;
                this.$validator.reset();
            }.bind(this));
            this.$bvModal.show('bv-modal-cost-center');
        },
        deleteCostCenter: function (x) {
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this cost center.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url + '/cost-center-delete', formData).then(function (response) {
                            if (response.data == '1') {
                                this.getAllCostCenters();
                                this.$bvToast.toast('Deleted!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                            }
                            else {
                                this.getAllCostCenters();
                                this.$bvToast.toast('Not Deleted!', {
                                    title: `Failed`,
                                    variant: 'danger',
                                    solid: true
                                });
                            }
                        }.bind(this));
                    }
                })
                .catch(function (error) //server error
                {
                    currentObj.serverError(error);

                });
        },
        showDetails: function (x) {
            axios.get(this.$api_url + '/cost-center-show-details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.costcenterdetails_basic = response.data.basic;
                this.costcenterdetails_house_rent = response.data.hr;
                this.costcenterdetails_conveyance = response.data.ca;
                this.costcenterdetails_medical = response.data.ma;
                this.costcenterdetails_other = response.data.other;
                this.costcenterdetails_income_tax = response.data.incomeTax;
                this.costcenterdetails_one_off = response.data.OneOffTax;
                this.costcenterdetails_net_paid = response.data.netSalaryPaid;
                this.costcenterdetails_credit = response.data.credit;
                this.short_code = response.data.short_code;
                this.cost_center_name = response.data.name;
                this.cost_center_id = x;
            }.bind(this));
            this.$bvModal.show('bv-modal-show-cost-center');
        },
        editCostCenterPayroll: function (x) {
            this.resetOptionsForm();
            var cost_center_id = this.cost_center_id;
            axios.get(this.$api_url + '/cost-center-edit-details', {
                params: {
                    id: x,
                    cost_center_id: cost_center_id,
                }
            }).then(function (response) {
                this.costdata_payroll = response.data;
                this.cost_center_id = response.data.cost_center_id;
                this.company_id = response.data.company_id;
            }.bind(this));
            this.$bvModal.show('bv-modal-show-edit-details');
        },
        onSubmitCostCenterOptions(e) {
            e.preventDefault();
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();
                var cost_center_id = this.cost_center_id;
                var company_id = this.company_id;
                for (let [key, value] of Object.entries(this.costdata_payroll)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                }
                formData.append('cost_center_id', cost_center_id);
                formData.append('company_id', company_id);
                this.showoverlay = true;

                axios.post(this.$api_url + '/cost-center-payroll-save', formData, config)
                    .then(function (response) {
                        if (response.data.message != 'Saved') {
                            this.$bvToast.toast(response.data.message, {
                                title: `Failed`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                        else {
                            this.$bvToast.toast("Saved", {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                            this.resetOptionsForm();
                            this.costcenterdetails_basic = response.data.costcenters.basic;
                            this.costcenterdetails_house_rent = response.data.costcenters.hr;
                            this.costcenterdetails_conveyance = response.data.costcenters.ca;
                            this.costcenterdetails_medical = response.data.costcenters.ma;
                            this.costcenterdetails_other = response.data.costcenters.other;
                            this.costcenterdetails_income_tax = response.data.costcenters.incomeTax;
                            this.costcenterdetails_one_off = response.data.costcenters.OneOffTax;
                            this.costcenterdetails_net_paid = response.data.costcenters.netSalaryPaid;
                            this.costcenterdetails_credit = response.data.costcenters.credit;
                        }
                        this.$bvModal.hide('bv-modal-show-edit-details');
                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                    });

                this.showoverlay = false;
            });
        },
        processCostCenter: function () {
            this.$bvModal.show('bv-modal-cost-center-process');
        },
        onSubmitUploadFileProcess: function (e) {
            e.preventDefault();
            let currentObj = this;
            let formData = new FormData();
            var cost_center_file_process = this.cost_center_file_process;
            console.log(cost_center_file_process);

            formData.append('file', cost_center_file_process);
            axios.post(this.$api_url + '/cost-center-import', formData)
                .then(function (response) {
                    if (response.data.status == 'File Imported Successfully') {
                        this.$bvToast.toast(response.data.message, {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                    }
                    else {
                        this.$bvToast.toast(response.data.message, {
                            title: `Failed`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                    this.resetAll();
                    this.getAllCostCenters();
                    this.$bvModal.hide('bv-modal-cost-center-process');

                }.bind(this))
                .catch(function (error) {
                    error.message = "Please upload correct file, format is wrong";
                    currentObj.$bvModal.hide('bv-modal-cost-center-import');
                    currentObj.$bvToast.toast(error.message, {
                        title: `Failed`,
                        variant: 'danger',
                        solid: true
                    });
                });
        },
        onChangeFileProcess: function (e) {
            var fileInput = document.getElementById('cost_center_file_process');

            var filePath = fileInput.value;

            var allowedExtensions =
                /(\.xls|\.xlsx)$/i;

            if (!allowedExtensions.exec(filePath)) {
                alert('Invalid file type');
                fileInput.value = '';
                return false;
            }
            else {
                return true;
            }
        },

        exportCostCenter() {
            let currentObj = this;
            axios.get(this.$api_url + '/cost-center-export-data')
                .then(function (response) {
                    window.open(response.data);
                }.bind(this))
                .catch(function (error) {
                    currentObj.serverError(error);
                });
        },
        importCostCenter: function () {
            this.$bvModal.show('bv-modal-cost-center-import');
        },
        onSubmitUploadFile: function (e) {
            e.preventDefault();
            let currentObj = this;
            let formData = new FormData();
            var cost_center_file = this.cost_center_file;
            console.log(cost_center_file);

            formData.append('file', cost_center_file);
            axios.post(this.$api_url + '/cost-center-import-payroll', formData)
                .then(function (response) {
                    if (response.data.status == 1) {
                        this.$bvToast.toast(response.data.message, {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });
                    }
                    else {
                        this.$bvToast.toast(response.data.message, {
                            title: `Failed`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                    this.resetAll();
                    this.$bvModal.hide('bv-modal-cost-center-import');

                }.bind(this))
                .catch(function (error) {
                    error.message = "Please upload correct file, format is wrong";
                    currentObj.$bvModal.hide('bv-modal-cost-center-import');
                    currentObj.$bvToast.toast(error.message, {
                        title: `Failed`,
                        variant: 'danger',
                        solid: true
                    });
                });
        },
        onChangeFile: function (e) {
            var fileInput = document.getElementById('cost_center_file');

            var filePath = fileInput.value;

            var allowedExtensions =
                /(\.xls|\.xlsx)$/i;

            if (!allowedExtensions.exec(filePath)) {
                alert('Invalid file type');
                fileInput.value = '';
                return false;
            }
            else {
                return true;
            }
        },
        updateSorting() {
            this.paginatedData.map((costcenter, index) => {
                costcenter.sorting_order = index + 1;
            })
            axios.put(this.$api_url + '/cost-center-update-sorting', {
                costcenters: this.paginatedData
            }).then((response) => {
                // success message
                this.getAllCostCenters();
            })
        }
    },
    created: function () {
        this.getAllCostCenters();
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.costcenters;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });
                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;

            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'reorder', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    return (a === b ? 0 : a > b ? 1 : -1) * order;
                });
            }

            this.pagination.total = filtered_list.length;
            this.pagination.pages = Math.ceil(filtered_list.length / this.length) || 1;

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
    }
}
</script>
